//import {LIVE_ADMIN} from "./app";
import {addToOrder} from "./order";
import {FastMessage} from "./fastmessages-new";
import {$document, $body} from "./globals";
import {frontendAndBackendFunctions, startStars} from "./common-new";
import {GroupFilter, resolveCanonical, resolveTitle} from "./group-filter";
import {imageLazyLoad} from "./lazyload";
import "./comparator";
import "../plugins/eshop/scripts/products.js";
import "../plugins/eshop/scripts/ares.js";

if (typeof CanUseWheelOfFortune != "undefined") {
    import("./wheeloffortune").then((module) => {
        module.wheelOfFortune(WOFSettings || [])
    })
}

export const filter = new GroupFilter($('.ProductList'), $('.GroupFilter.c-filters--sidebar'));

const $pProductList = $('.p-product-list');
if ($pProductList.length) {
    $pProductList.on('click', '.js-sidebar-toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".js-sidebar").toggleClass("is-open");
        $("html").toggleClass("has-modal-open");
    });
}
const customerCompany = $('.is_customer_company');
const shipToAddress = $('.ship_to_address_same_as_invoicing_address');

if (customerCompany.length || shipToAddress.length) {
    if (customerCompany.length) {
        customerCompany.on('change', function () {
            $('.companyInformationItems').slideToggle();
        }).trigger('change');
    }
    if (shipToAddress.length) {
        shipToAddress.on('change', function () {
            $('.shipAddress').slideToggle();
        }).trigger('change');
    }
}

if('retargetingCategoryConf' in window && window.rc && window.rc.retargetingHit) {
    window.rc.retargetingHit(window.retargetingCategoryConf);
}

$('main').on('click', '.c-catalog-item__images img', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const _this = $(this);
    const parent = _this.closest('.c-catalog-item__link');
    const image = parent.find('.c-catalog-item__image');
    image.fadeTo(500, 0.1, function () {
        image.attr('src', _this.attr('data-big'));
        image.on('load', function () {
            parent.find('.item.selected').removeClass('selected');
            _this.parent().addClass('selected');
            image.fadeTo(500, 1);
        });
    });
});

$document.on('click', '.AddToBasket a', function (e) {
    e.preventDefault();
    const _this = $(this);
    const id_product = _this.attr('data-product-id');
    const count = _this.closest('[data-jquery=addProductToOrderContainer]').find('[data-jquery=addProductToOrderCount]').val();
    const simple = _this.attr('data-simple');
    if (_this.attr('data-jquery') === 'addSetProductToOrder') {
        addToOrder(id_product, count, simple, (function () {
            var products = [];
            $('.c-size-item input:checked').each(function () {
                var set = {};
                set[this.getAttribute('data-parent-id')] = this.getAttribute('data-product-id');
                products.push(set);
            });
            return products;
        })(), _this.attr('data-price'));
    } else {
        addToOrder(id_product, count, simple, undefined, _this.attr('data-price'));
    }
});

$document.on('change', '.PlusMinusInput[type=number]:not(.detail)', function (e) {

    const self = $(this);
    let value = self.val();
    if (value <= 0) {
        self.val(1);
        value = 1;
    }

    const dataToSend = new FormData();
    dataToSend.append("func", 'calculate_prices');
    const productId = self.attr("product-id");
    dataToSend.append("product-id", productId);
    dataToSend.append("count", value);
    if (self.attr('data-uid')) {
        dataToSend.append("uid", self.attr('data-uid'));
    }

    $.ajax({
        type: "POST",
        contentType: false,
        cache: false,
        processData: false,
        url: ABSOLUTE_URL + "plugins/eshop/ajax.php",
        dataType: "json",
        data: dataToSend,
        success: function (data) {
            if ('noOrder' in data) {
                FastMessage.createMessage(data.noOrder, FastMessage.error);
            } else {
                if (data !== "refresh") {
                    $('#price-' + data.order_item_id).text(data.newPrice);
                    $('#priceWithoutVAT-' + data.order_item_id).text(data.newPriceWithoutVAT);
                    $('#allPrice').text(data.allPrice);
                    $('#allPriceVAT').text(data.allPriceVAT);
                    $('#free-delivery-progress-bar').html(data.progressBar);
                    $('#weight').text(data.weight + " kg");
                    $('.BasketBox').html(data.basket);
                    handleRustyData(data);
                    if (data.wholeBasket) {
                        $('.c-cart-table__products').html(data.wholeBasket);
                    }
                    if ('freeItemMessage' in data) {
                        FastMessage.createMessage(data.freeItemMessage.message, data.freeItemMessage.type);
                    }
                    if('GA' in data){
                        gtag("event", "add_to_cart", {
                            send_to: GA4,
                            ...data.GA
                        });
                        gtag("event", "add_to_cart", {
                            send_to: GADS,
                            ...data.GA
                        });
                    }
                } else {
                    location.reload();
                }
            }
        }
    });

});

$body.on('click', '.c-cart-select__item  .extension label', function () {
    var _ = $(this);
    _.closest('.c-cart-select__label').children('input').prop('checked', true);
});

$document.on('click', '.removeFromBasket', function (e) {
    e.preventDefault();
    const _this = $(this);
    const self = _this.closest(".orderItems");
    const dataToSend = new FormData();
    const productId = _this.attr("data-productid");
    dataToSend.append("func", 'remove_product');
    dataToSend.append("product-id", productId);
    if (_this.attr('data-uid')) {
        dataToSend.append("uid", _this.attr('data-uid'));
    }
    $.ajax({
        type: "POST",
        contentType: false,
        cache: false,
        processData: false,
        url: ABSOLUTE_URL + "plugins/eshop/ajax.php",
        dataType: "json",
        data: dataToSend,
        success: function (data) {
            if ('noOrder' in data) {
                FastMessage.createMessage(data.noOrder, FastMessage.error);
            } else {
                if (data.emptyBasket) {
                    $('.BasketBox').replaceWith(data.basket);
                    $('.BasketForm').replaceWith(data.emptyBasket);

                } else if (data !== "refresh") {
                    self.slideUp(function () {
                        $(this).remove();
                    });
                    $('#allPrice').text(data.allPrice);
                    $('#allPriceVAT').text(data.allPriceVAT);
                    $('#weight').text(data.weight + " kg");
                    $('.BasketBox').replaceWith(data.basket);
                    const buyedAlso = $('.c-buyed-also');
                    if (buyedAlso.length && typeof data.buyedAlso !== undefined && data.buyedAlso) {
                        buyedAlso.replaceWith(data.buyedAlso);
                        startStars();
                    } else if (buyedAlso.length && typeof data.buyedAlso !== undefined) {
                        $('.js-buyed-also').fadeOut('slow', function () {
                            $(this).remove();
                        });
                    }
                    handleRustyData(data);
                    if (data.wholeBasket) {
                        $('.c-cart-table__products').html(data.wholeBasket);
                    }
                    if ('freeItemMessage' in data) {
                        FastMessage.createMessage(data.freeItemMessage.message, data.freeItemMessage.type);
                    }
                    FastMessage.createMessage("Produkt byl odebrán z košíku.", FastMessage.success);
                } else {
                    location.reload();
                }
            }
        }
    });

});

$body.on('click', '.showNextProducts', function (e) {
    e.preventDefault();
    GroupFilter.showLoading();
    const $container = $('.ProductList');
    const url = $(this).attr('href');
    $.ajax({
        url: url,
        dataType: 'json',
        success: function (data) {
            const $r_html = $(data.html);
            $container.find('.c-paginator').remove();
            $container.append($r_html.html());
            if (typeof data.canonicalUrl != "undefined") {
                resolveCanonical(data.canonicalUrl);
            }
            if (typeof data.title != 'undefined') {
                resolveTitle(data.meta_title, data.title);
            }
            window.history.pushState({path: url}, '', url);
            imageLazyLoad();
            GroupFilter.removeLoading();
            frontendAndBackendFunctions();
        }
    });
})

$body.on('change', '[data-jquery="CatalogSorting"]', function (e) {
    e.preventDefault();
    GroupFilter.showLoading();
    const url = $(this).val();
    $.ajax({
        url: url,
        dataType: 'json',
        success: function (data) {
            const $r_html = $(data.html);
            $('.ProductList').html($r_html.html());
            $('.c-catalog__filter-row').html($(data.sorting).html());
            window.history.pushState({path: url}, '', url);
            imageLazyLoad();
            GroupFilter.removeLoading();
            frontendAndBackendFunctions();
        }
    });
});

$body.on('change', '#CatalogViewSettings-paging', function (e) {
    e.preventDefault();
    GroupFilter.showLoading();
    var url = $(this).val();
    $.ajax({
        url: url,
        dataType: 'json',
        success: function (data) {
            const $r_html = $(data.html);
            $('.ProductList').html($r_html.html());
            $('.c-catalog__filter-row').html($(data.sorting).html());
            window.history.pushState({path: url}, '', url);
            imageLazyLoad();
            GroupFilter.removeLoading();
            frontendAndBackendFunctions();
        }
    });
});

$body.on('click', '.ProductList .c-paginator .Page a', function (e) {
    e.preventDefault();
    GroupFilter.showLoading();
    const $container = $(this).closest('.ProductList');
    const url = $(this).attr('href');
    $.ajax({
        url: url,
        dataType: 'json',
        success: function (data) {
            $('html, body').animate({
                scrollTop: $container.parent().offset().top
            }, 150, function () {
                imageLazyLoad();
            });
            const $r_html = $(data.html);
            $container.find('.c-paginator').remove();
            $container.html($r_html.html());
            if (typeof data.canonicalUrl != "undefined") {
                resolveCanonical(data.canonicalUrl);
            }
            if (typeof data.title != 'undefined') {
                resolveTitle(data.meta_title, data.title);
            }
            window.history.pushState({path: url}, '', url);
            GroupFilter.removeLoading();
            frontendAndBackendFunctions();
        }
    });
});

$body.on('click', '.ProductList .ProductListItem a', function (e) {
    e.preventDefault();
    const actual = $(this);
    const productOid = actual.closest('.ProductListItem').attr('data-jquery');
    const pageNumber = actual.closest('[data-page-number]').attr('data-page-number');
    let search = '';
    let sorting = '';
    let items = '';
    if ($.urlParam('search') && $.urlParam('search').length > 0) {
        search = '&search=' + $.urlParam('search');
    }
    if ($.urlParam('item_on_page') && $.urlParam('item_on_page').length > 0) {
        items = $.urlParam('item_on_page');
    }
    if ($.urlParam('sorting') && $.urlParam('sorting').length > 0) {
        sorting = '&sorting=' + $.urlParam('sorting');
    }
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?page=' + pageNumber + '&item_on_page=' + items + '&previous=' + productOid + search + sorting;
    window.history.pushState({path: newurl}, '', newurl);
    window.location.href = actual.attr('href');
    return false;
});

if ($('.GroupDetail').length > 0 && $.urlParam('previous') > 0) {
    $('html, body').animate({
        scrollTop: $('.ProductListItem[data-jquery=' + $.urlParam('previous') + ']').offset().top
    }, 1000);
}

const glsBranchOpen = $('.glsBranchOpen');
if (glsBranchOpen.length) {
    import('./gls').then(module => {
        module.gls(glsBranchOpen);
    });
}

const cpBranchOpen = $('.cpBranchOpen');
if (cpBranchOpen.length) {
    import('./cp').then(module => {
        module.cp(cpBranchOpen);
    });
}

$document.on('click', '.c-order-gift__product .c-size-item', function (e){
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
    const _ = $(this);
    _.closest('.c-order-gift__product').find('.c-cart-select__title').prop('checked', true);
    _.children('input').prop('checked', true);
});

function handleRustyData(data) {
    if ('addRustyCoupon' in data) {
        import('./rusty').then(module => {
            module.rustyModal($body);
        });
    }
    if ('removeRustyCoupon' in data) {
        import('./rusty').then(module => {
            module.removeRustyCoupon(data.rustyCouponMessage);
        });
    }
}

const odf = $('.OderDeliveryForm');
if(odf.length){
    import('./delivery-form').then(module => {
        module.init(odf);
    })
}